import { falsy } from "./index.js";
export default function() {
  let functions = [];
  const add = (fn) => {
    functions.push(fn);
  };
  const remove = (fn) => {
    functions = functions.filter((v) => v !== fn);
  };
  const getDropAreas = (items) => functions.flatMap((fn) => {
    const v = fn(items);
    if (v) {
      return v;
    }
    return null;
  }).filter(falsy);
  return {
    add,
    remove,
    getDropAreas
  };
}
